<template>
  <div class="inner-box">
    <div slot="content">
      <el-form size="medium" @submit.prevent>
        <div class="content-name">
          <h2 class="dp-ib">{{ routeName }}</h2>
          <el-form-item label-width="0px" style="float: right;">
            <el-button type="primary" icon="el-icon-plus" @click="save" v-show="this.showGrant">
              저장
            </el-button>
            <el-button type="danger" icon="el-icon-delete-solid" @click="buttonClickEventRemove" v-show="this.showGrant">
              삭제
            </el-button>
            <el-button type="info" icon="el-icon-close" @click="cancel" v-show="this.showGrant">
              취소
            </el-button>
            <el-button type="success" icon="el-icon-document-checked" @click="excelUpload">엑셀업로드</el-button>
            <el-button type="success" icon="el-icon-document-checked" @click="excelDown">엑셀다운로드</el-button>
            <el-button type="primary" icon="el-icon-search" @click="goOpen">
              {{ this.$i18n.messages[this.$store.state.locale].search }}
            </el-button>
          </el-form-item>
        </div>
      </el-form>

      <div class="search-form">
        <el-form size="mini">
          <el-row style="margin-bottom: 0px;">
            <el-col :span="10">
              <el-form-item label="처리요청일" label-width="100px">
                <el-row>
                  <el-col :span="11">
                    <el-date-picker type="date" placeholder="시작일" v-model="form.startDt" style="width: 100%;" value-format="yyyy-MM-dd"></el-date-picker>
                  </el-col>
                  <el-col :span="1" style="text-align: center;">-</el-col>
                  <el-col :span="12">
                    <el-date-picker type="date" placeholder="종료일" v-model="form.endDt" style="width: 100%;" value-format="yyyy-MM-dd"></el-date-picker>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="의뢰구분" label-width="100px">
                <el-select v-model="form.maType" >
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['maType']"
                      :key="item.key"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-row>
                <el-form-item label="지역/처리센터" label-width="120px">
                  <el-col :span="10">
                    <el-select v-model="form.catId" @change="onCatIdChange">
                      <el-option value='' label="전체">전체</el-option>
                      <el-option
                          v-for="item in combos['catId']"
                          :key="item.key"
                          :value="item.key"
                          :label="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="14">
                    <el-select v-model="form.subCatId" v-show="changeCatIdShow">
                      <el-option value='' label="전체">전체</el-option>
                      <el-option
                          v-for="item in combos['subCatId']"
                          :key="item.key"
                          :value="item.key"
                          :label="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 0px;">
            <el-col :span="10">
              <el-form-item label="고객구분" label-width="100px">
                <el-select v-model="form.siteType">
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['siteType']"
                      :key="item.value"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="14">
              <el-form-item label="사이트명" label-width="100px">
                <el-row>
                  <el-col>
                    <el-col :span="8">
                      <el-input type="text" v-model="form.siteNm1" @keyup.native.enter="goOpen"></el-input>
                    </el-col>
                    <el-col :span="8">
                      <el-input type="text" v-model="form.siteNm2" @keyup.native.enter="goOpen"></el-input>
                    </el-col>
                    <el-col :span="8">
                      <el-input type="text" v-model="form.siteNm3" @keyup.native.enter="goOpen"></el-input>
                    </el-col>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <div class="table-area">
      <div class="table-b">
        <div class="table-header">
          <div class="grid-tbl-box">
            <ag-grid-vue
                ref="grid"
                :style="gridStyle"
                class="ag-theme-alpine"
                row-selection="single"
                :column-defs="columnDefs"
                :grid-options="mainGridOptions"
                :row-data="data"
                :default-col-def="defaultColDef"
                :framework-components="frameworkComponent"
                :statusBar="statusBar"
                @selection-changed="onSelectionChangedSub"
                @grid-ready="onReadyMain" />
            <ag-grid-vue
                ref="gridTemp"
                :style="gridStyle"
                class="ag-theme-alpine"
                :column-defs="columnTemp"
                :grid-options="tempGridOptions"
                :row-data="tempData"
                :default-col-def="defaultColTemp"
                :framework-components="frameworkComponent"
                :statusBar="statusBar"
                v-show="false"/>
        </div>
        </div>
      </div>
    </div>
    <bs-ma-edit-info ref="bsMaEditInfo" :bsMaEditDetail="bsMaEditDetail" style="height: 100%"/>
  </div>
</template>

<script>

import lucoms from '@/mixin/lucoms';

import DatepickerCellRenderer from "@/components/agGrid/datepicker-cell-renderer";
import MaskEditCellRenderer from "@/components/agGrid/maskedit-cell-renderer";
import SelectCellRenderer from "@/components/agGrid/select-cell-renderer";
import CheckboxCellRenderer from "@/components/agGrid/checkbox-cell-renderer";
import RadioCellRenderer from "@/components/agGrid/radio-cell-renderer";
import NumberInputCellRender from "@/components/agGrid/numberinput-cell-renderer";
import InputCellRender from "@/components/agGrid/input-cell-renderer";
import ButtonCellRenderer from "@/components/agGrid/button-cell-renderer";
import BsMaEditInfo from '@/components/WorkMng/BsMaEditInfo/BsMaEditInfo.vue';
import _ from "lodash";
import BsMaUploadExcel from "@/components/WorkMng/BsMaEditInfo/BsMaUploadExcel";

function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

export default {
  mixins: [lucoms],
  props: {
  },
  components: {BsMaEditInfo},
  data() {
    return {
      data: [],
      tempData: [],
      form: {
        companyId : '',
        startDt: this.$moment().subtract(1, 'months').add(1, 'days').format('YYYY-MM-DD'),
        endDt: this.$moment().format('YYYY-MM-DD'),
        maType : '',             // 의뢰구분
        siteType : '',           // 고객구분
        catId : '',              // 지역
        subCatId: '',            // 지역상세
        sortType : '',           // 승인/정산처리유형
        siteNm1 : '',            // 사이트명1
        siteNm2 : '',            // 사이트명2
        siteNm3 : '',            // 사이트명3
        page : 1,
        totalPage : 9999,
        curPage : 0,
        totalCount : 9999,
        processTime : ''
      },
      combos: {
        'maType' : [],
        'catId' : [],
        'subCatId' : [],
        'siteType' : [],
        'procType' : [],
      },
      changeCatIdShow : false,
      // AG-GRID OPTION [START]
      gridStyle : 'padding-top: 10px; width: 100%;height: 300px; min-height:100px;',
      defaultColDef: {
          resizable: true
        , filter:false
        , sortable: true
      },
      mainGridApi: null,
      mainColumnApi: null,
      mainGridOptions: {
        enableColResize: true,
        enableFilter: true,
        animateRows: false,
        enableSorting: true,
      },
      columnTemp: [],
      tempGridApi: null,
      tempColumnApi: null,
      tempGridOptions: {
        enableColResize: true,
        enableFilter: true,
        animateRows: false,
        enableSorting: true,
      },
      defaultColTemp: {
        resizable: true
        , filter:false
        , sortable: true
      },
      columnDefs: [],
      frameworkComponent : {
        datePicker: DatepickerCellRenderer,
        maskEdit: MaskEditCellRenderer,
        select: SelectCellRenderer,
        checkBox: CheckboxCellRenderer,
        radio: RadioCellRenderer,
        numberInput: NumberInputCellRender,
        input: InputCellRender,
        button: ButtonCellRenderer
      },
      showGrant: true,
      statusBar: null,
      bsMaEditDetail: []
    }
  },
  methods: {
    onReadyMain() {
      this.mainGridApi = this.mainGridOptions.api;
      this.mainColumnApi = this.mainGridOptions.columnApi;

      this.init();
      this.getProcType();
    },
    createMainColumnDefs() {
      const vm = this
      this.columnDefs = [
        {
          headerName:'No',
          field:'no',
          width:80,
          cellStyle:{textAlign: 'center'},
          valueFormatter: function(params) {
            return params.node.rowIndex+1;
          }
        },
        {headerName:'의뢰번호', field:'requestId', width:150},
        {headerName:'의뢰일자', field:'requestDt', width:110, cellStyle:{textAlign: 'center'},
          valueFormatter: (params) => {
            return params.value === null  ? '' : vm.getDateFormat(`${params.value}`) ;
          }},
        {headerName:'의뢰구분', field:'maType', width:110, cellStyle:{textAlign: 'center'}},
        {headerName:'사이트명', field:'siteNms', width:160,
          valueGetter: (params) => {
            return params.data.siteNm1 + ' ' + params.data.siteNm2 + ' ' + params.data.siteNm3
          }},
        {headerName:'고객명', field:'chargeNm', width:160},
        {headerName:'전화번호', field:'telNo', width:140},
        {headerName:'휴대폰', field:'hpNo', width:140},
        {headerName:'모델명', field:'modelNm', width:140},
        {headerName:'수량', field:'modelQty', width:80, cellStyle:{textAlign: 'right'}},
        {headerName:'작업내용', field:'workDetails', width:180},
        {headerName:'처리센터', field:'asAgentNm', width:140},
        {headerName:'처리일자', field:'procDt', width:110, cellStyle:{textAlign: 'center'},
          valueFormatter: (params) => {
            return params.value === null  ? '' : vm.getDateFormat(`${params.value}`) ;
          }},
      ];

      this.columnTemp = [
        {
          headerName:'순번',
          field:'no',
          width:80,
          cellStyle:{textAlign: 'center'}
        },
        {headerName:'의뢰번호', field:'requestId', width:150},
        {headerName:'의뢰일자', field:'requestDt'},
        {headerName:'구분', field:'maType', width:110, cellStyle:{textAlign: 'center'}},
        {headerName:'사이트명', field:'siteNms'},
        {headerName:'고객명', field:'chargeNm', width:160},
        {headerName:'전화번호', field:'telNo', width:140},
        {headerName:'휴대폰', field:'hpNo', width:140},
        {headerName:'모델명', field:'modelNm', width:140},
        {headerName:'수량', field:'modelQty', width:80, cellStyle:{textAlign: 'right'}},
        {headerName:'작업내용', field:'workDetails', width:180},
        {headerName:'처리센터', field:'asAgentNm', width:140},
        {headerName:'처리일자', field:'procDt'},
        {headerName:'의뢰자', field:'requestNm', width:160},
        {headerName:'고객구분', field:'siteType', width:160},
        {headerName:'사이트명', field:'siteNms', width:160},
        {headerName:'주소', field:'addr', width:140},
        {headerName:'처리내역', field:'procType', width:140},
        {headerName:'처리요청일', field:'requestDt', width:140},
        {headerName:'처리기사', field:'userNm', width:140},
        {headerName:'특기사항', field:'memo', width:140},
        {headerName:'처리비', field:'procUnitPrice1', width:140},
        {headerName:'단가', field:'procUnitPrice2', width:140},
        {headerName:'출장급지', field:'procEtcPrice1', width:140},
        {headerName:'기타비용', field:'procEtcPrice2', width:140},


      ];
    },
    onSelectionChangedSub(event) {
      this.gridApiSub = this.mainGridOptions.api;
      const voRow = this.gridApiSub.getSelectedRows() //선택된 Row
      //this.productInstallEditDetail = []; // 초기화
      let that = this
      this.$store.commit('loading')
      const vForm = {
        companyId : this.form.companyId,
        mstType : '',
        requestId: voRow[0].requestId
      }
      this.$http.post(_url("/api/workMng/bsMaEdit/selectList"), vForm)
          .then(response => {
            this.bsMaEditDetail = response.data;
            //this.bsMaEditDetail.data = response.data.uvwBsMaItemD
            this.bsMaEditDetail.uvwBsMaItemM[0].siteTypeCombo = this.combos['siteType']
            this.showGrant = this.bsMaEditDetail.uvwBsMaItemM[0].procYn == 'Y' ? false : true;
          }).finally(() => {
        this.$store.commit('finish')
      });

    },
    goOpen() {
      let that = this
      this.$store.commit('loading')
      const vForm = {
        companyId : this.form.companyId,
        startDt: this.form.startDt,
        endDt: this.form.endDt,
        maType : this.form.maType,              // 의뢰구분
        siteType : this.form.siteType,          // 고객구분
        catId : (this.form.subCatId.length <= 0 || this.form.subCatId === '')  ? (this.form.catId === '' ? 0 : this.form.catId) : this.form.subCatId,     // 지역
        subCatId: '',                           // 지역 상세
        sortType : this.form.sortType,          // 승인/정산처리유형
        siteNm1 : this.form.siteNm1,            // 사이트명1
        siteNm2 : this.form.siteNm2,            // 사이트명2
        siteNm3 : this.form.siteNm3,            // 사이트명3
        page : this.form.page,
        totalPage : this.form.totalPage,
        curPage : this.form.curPage,
        totalCount : this.form.totalCount,
        processTime : this.form.processTime
      }
      this.$http.post(_url("/api/workMng/bsMaEdit/list"), vForm)
          .then(response => {
            this.data = response.data.map(x=>{
              x.siteNms = (x.siteNm1 || '') + ' ' + (x.siteNm2 || '') + ' ' + (x.siteNm3 || '')
              return x
            });

            this.tempSet(this.data);

          }).finally(() => {
            this.$refs.bsMaEditInfo.form =  this.$refs.bsMaEditInfo.defForm;
            this.$store.commit('finish')
      });
    },
    excelUpload(){
      /** 엑셀업로드 */
      let vm = this;
      this.$modal.open({
        width: 800,
        component: BsMaUploadExcel,
        parent: this,
        props: {
          data: {

          },
        },
        events: {
          close(param) {
            // vm.form.maker = param.data.maker /** 제조사 */
            // vm.form.makerNm = param.data.makerNm /** 제조사명 */
            // vm.form.modelGroupNm = param.data.modelGroupNm /** 모델그룹명 */
            // vm.form.modelGroup = param.data.modelGroup /** 모델그룹 */
            // vm.form.standardModelNm = param.data.standardModelNm /** 표준모델 */
            // vm.form.modelNm = param.data.modelNm /** 모델명 */
            // vm.form.modelId = param.data.modelId /** 모델ID */
            vm.goOpen();
            // vm.tempData = [];
          },
        }
      });

    },
    excelDown(){
      this.tempGridOptions.api.exportDataAsExcel({fileName: 'BS_MA등록'});
    },
    tempSet(data){
      let no = 0;
      this.tempData = [];
      data.forEach(x=>{
        no = no+1;
        this.combos['siteType'].forEach(y=>{
          if(x.siteType === y.key) x.siteType = y.value;
        });
        this.combos['procType'].forEach(y=>{
          if(x.procType === y.key) x.procType = y.value;
        });

        this.tempData.push({
              no : no,
              requestId : x.requestId ,
              requestDt : this.getDateFormat(x.requestDt),
              maType : x.maType ,
              siteNms : x.siteNms ,
              chargeNm : x.chargeNm ,
              telNo : x.telNo ,
              hpNo : x.hpNo ,
              modelNm : x.modelNm ,
              modelQty : x.modelQty ,
              workDetails : x.workDetails ,
              asAgentNm : x.asAgentNm ,
              addr : x.addr1 + " " + x.addr2 ,
              procDt : this.getDateFormat(x.procDt),
              requestNm : x.requestNm ,
              siteType : x.siteType ,
              procType : x.procType ,
              userNm : x.userNm ,
              memo : x.memo ,
              procUnitPrice1 : x.procUnitPrice1 ,
              procUnitPrice2 : x.procUnitPrice2 ,
              procEtcPrice1 : x.procEtcPrice1 ,
              procEtcPrice2 : x.procEtcPrice2
        })
      });
    },
    getProcType(){
      this.$http.get(`/api/codeMng/combo`, { params: {parentId: 247} })
          .then(response => {
            this.combos['procType'] = response.data || []
          });
    },
    updateCount(){
      if(!this.$refs.bsMaEditInfo.validation()) return;

      this.$swal({
        type: 'info',
        text: `입고 수량을 수정 하시겠습니까?`,
        showCancelButton: true,
        confirmButtonText: '예',
        cancelButtonText: '아니오',
      }).then((result) => {
        if (result.value) {
          const bsMaEditInfo = JSON.parse(JSON.stringify(this.$refs.bsMaEditInfo.form));

          this.$http.get(`/api/asMng/call/config`, {params: {keyPath: 'System.MainAsAgentId'}})
              .then(response => {
                bsMaEditInfo.asAgentId = response.data[0].configValue
                this.$http.post(`/api/workMng/mateEntering/update`, bsMaEditInfo).then((response) => {
                  this.$swal({type: 'info', text: '저장되었습니다.'});
                  this.goOpen();
                }).catch((e) => {
                  this.$swal({type: 'error', text: e.response.data.message});
                });

              });
        }
      });
    },
    buttonClickEventRemove() {
      try{
        const selectedRows = this.mainGridOptions.api.getSelectedRows()

        //Selected Index
        const row = this.mainGridOptions.api.getSelectedNodes()
        const rowIndex = row.length < 1 ? -1 : row[0].rowIndex

        if(selectedRows == null|| rowIndex<0) throw '선택된 행이 없습니다.'

        if(selectedRows.length > 0) {
          this.$store.commit('loading');
          this.$http.post('/api/workMng/bsMaEdit/delete', selectedRows)
              .then(response => {
                if (response) {
                  this.$swal({type: 'success', text: '삭제되었습니다.'});
                  this.data.splice(rowIndex,1)
                  this.focusRow(rowIndex-1);
                }
              }).catch(({message}) => {
                if (message === "Request failed with status code 500") {
                  this.$swal({type: "error", text: "오류가 발생했습니다."});
                }
              }).finally(() => {
            this.$store.commit('finish');
          })
        }
      }catch(e){
        this.$swal({
          type: 'warning',
          text: e
        })
      }
    },
    async init() {
      this.$store.commit('loading');
      await this.$http.post(`/api/workMng/bsMaEdit/init`)
          .then(response => {
            this.combos['maType'] = response.data.maType;
            this.combos['catId'] = response.data.catId;
            this.combos['siteType'] = response.data.siteType;
          }).finally(() => {
            this.goOpen();
            this.$store.commit('finish');
          });
      this.createMainColumnDefs();
    },
    onCatIdChange(param){
      this.form.subCatId = '';
      if(param === '') this.changeCatIdShow =  false;
      else{
        this.changeCatIdShow =  true;
        // 지역 상세
        this.$http.get(`/api/codeMng/combo/catId`, { params: {parentId: param} })
            .then(response => {
              this.combos['subCatId'] = response.data || []
            });
      }
    },
    validation(param) {

      console.log(param);

      if (!param.requestDt ) {
        this.$swal({type: 'warning', text: '의뢰일자를 입력해주세요.'});
        return false;
      }
      if (!param.requestNm ) {
        this.$swal({type: 'warning', text: '의뢰자를 입력해주세요.'});
        return false;
      }
      if (!param.requestNm ) {
        this.$swal({type: 'warning', text: '구분을 선택해주세요.'});
        return false;
      }
      if (!param.siteType ) {
        this.$swal({type: 'warning', text: '찾기버튼을 통해서 사이트를 선택해주세요.'});
        return false;
      }
      // if (!param.siteId ) {
      //   this.$swal({type: 'warning', text: '찾기버튼을 통해서 사이트를 선택해주세요.'});
      //   return false;
      // }
      if (!param.modelQty ) {
        this.$swal({type: 'warning', text: '의뢰대수를 입력해주세요.'});
        return false;
      }
      if (!param.requestProcDt ) {
        this.$swal({type: 'warning', text: '설치요청일을 입력해주세요.'});
        return false;
      }
      return true;
    },
    cancel(){
      this.$refs.bsMaEditInfo.form = _.clone(this.$refs.bsMaEditInfo.defForm);
      this.$refs.bsMaEditInfo.cancle();
    },
    /**
     * 저장/수정
     */
    save() {
      const param = JSON.parse(JSON.stringify(this.$refs.bsMaEditInfo.form));
      const stripFields = ['requestDt', 'requestNm', 'siteType', 'modelQty', 'requestProcDt'];
      _.forEach(stripFields, (name) => param[name] = this.toPure(param[name]));

      if (!this.validation(param)) return;


      if(param.userId == ""){
        this.$swal({type: 'warning', text: '기사명은 필수 입력 사항입니다.'});
        return false;
      }else if(param.asAgentId == ""){
        this.$swal({type: 'warning', text: '지역상세는 필수 입력 사항입니다.'});
        return false;
      }else if(param.catId == ""){
        this.$swal({type: 'warning', text: '지역은 필수 입력 사항입니다.'});
        return false;
      }

      let vSaveForm = {
        companyId : this.form.companyId,
        maType : this.$refs.bsMaEditInfo.form.maType,
        requestDt : this.$refs.bsMaEditInfo.form.requestDt,
        requestNm : this.$refs.bsMaEditInfo.form.requestNm,
        siteId : this.$refs.bsMaEditInfo.form.siteId,
        zipCd : this.$refs.bsMaEditInfo.form.zipCd,
        addr1 : this.$refs.bsMaEditInfo.form.addr1,
        addr2 : this.$refs.bsMaEditInfo.form.addr2,
        chargeNm : this.$refs.bsMaEditInfo.form.chargeNm,
        telNo : this.$refs.bsMaEditInfo.form.telNo,
        hpNo : this.$refs.bsMaEditInfo.form.hpNo,
        modelId : this.$refs.bsMaEditInfo.form.modelId,
        modelQty : this.$refs.bsMaEditInfo.form.modelQty,
        procType : this.$refs.bsMaEditInfo.form.procType,
        requestProcDt : this.$refs.bsMaEditInfo.form.requestProcDt,
        asAgentId : this.$refs.bsMaEditInfo.form.asAgentId,
        workDetails : this.$refs.bsMaEditInfo.form.workDetails,
        memo : this.$refs.bsMaEditInfo.form.memo,
        procUnitPrice1 : this.$refs.bsMaEditInfo.form.procUnitPrice1.replace(',', ''),
        procUnitPrice2 : this.$refs.bsMaEditInfo.form.procUnitPrice2 == '' ? 0 : this.$refs.bsMaEditInfo.form.procUnitPrice2.replace(',', ''),
        procEtcPrice1 : this.$refs.bsMaEditInfo.form.procEtcPrice1 == '' ? 0 : this.$refs.bsMaEditInfo.form.procEtcPrice1.replace(',', ''),
        procEtcPrice2 : this.$refs.bsMaEditInfo.form.procEtcPrice2 == '' ? 0 : this.$refs.bsMaEditInfo.form.procEtcPrice2.replace(',', ''),
        userId : this.$refs.bsMaEditInfo.form.userId,
        requestId : this.$refs.bsMaEditInfo.form.requestId,
      }

      let itemData = this.$refs.bsMaEditInfo.data;
      let submitList = [];
      let delData = this.$refs.bsMaEditInfo.delData;

      for(var i=0; itemData.length > i; i++){
        submitList.push({
          companyId: this.$store.state.loginInfo.compCd,
          bsMaItemId : itemData[i].bsMaItemId ==  undefined ? 0 : itemData[i].bsMaItemId,
          requestId : this.$refs.bsMaEditInfo.form.requestId,
          productType : 'Item',
          itemId : itemData[i].itemId,
          itemGoodQty : itemData[i].applyItemGoodQty,
          itemRecycleQty : itemData[i].itemRecycleQty == null ? 0 : itemData[i].itemRecycleQty,
          recallItemId : itemData[i].itemId,
          recallItemQty : itemData[i].applyRecallItemQty
        });
      }


      this.$swal({
        type: 'warning',
        text: `저장 하시겠습니까?`,
        showCancelButton: true,
        confirmButtonText: '예',
        cancelButtonText: '아니오',
      }).then((result) => {
        if (result.value) {
          this.$store.commit('loading')
          this.$http.post(("/api/workMng/bsMaEdit/save"), vSaveForm).then(response => {
            if(response.data.indexOf("BS") !== -1) {
              submitList.forEach(x => {
                x.requestId = response.data;
              })
            }
              if(delData.length>0){ // 삭제한 내용이 있다면
                this.$http.post(("/api/workMng/bsMaEdit/item/delete"), delData).then(response => {
                  this.$http.post(("/api/workMng/bsMaEdit/item/save"), submitList).then(response => {
                    this.$swal({ type: 'success', text: '저장되었습니다.' })
                    this.goOpen();
                  }).catch((e) => {
                    this.$swal({ type: 'success', text: '저장에 실패 했습니다.' })
                  })
                }).catch((e) => {
                  this.$swal({ type: 'success', text: '저장에 실패 했습니다.' })
                })
              }else{
                this.$http.post(("/api/workMng/bsMaEdit/item/save"), submitList).then(response => {
                  this.$swal({ type: 'success', text: '저장되었습니다.' })
                  this.goOpen();
                }).catch((e) => {
                  this.$swal({ type: 'success', text: '저장에 실패 했습니다.' })
                })
              }
          }).catch((e) => {
            console.error(e);
            this.$swal({ type: 'success', text: '저장에 실패 했습니다.' })
          }).finally(() => {
            this.$store.commit('finish')
          });
        }
      });
    },
  },
  created() {
    this.statusBar = {
      statusPanels: [
        { statusPanel: 'agTotalRowCountComponent', align: 'right' },
      ],
    };
  },
  mounted() {
    this.form.companyId = this.$store.state.loginInfo.compCd;
  },
  computed: {
    routeName() {
      return this.$route.name
    }
  },
}
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
</style>